import * as yup from "yup";

export const validationSchema = yup.object().shape({
  lectureCode: yup.string().required("Meeting Code is required."),
});

export const initValues = { lectureCode: "" };
